/**
 * One size table for every drag handle on the plan — object resize
 * handles, wall end handles, cabinet-run end handles.
 *
 * `coarse` is the caller's word for "a finger is the pointer"
 * (`useCoarsePointer`, threaded through the gesture and render hooks as
 * `grabHandlesEnabled`). It replaces three copies of a module-level
 * `'ontouchstart' in window || navigator.maxTouchPoints > 0` constant,
 * which was true on every touch-panel Windows laptop with a mouse in
 * hand, and which could never follow a hybrid device from mouse to
 * finger mid-session.
 *
 * Sizes are screen pixels; callers divide by the canvas scale.
 * `hitPx` is the full width of the hit square (or the diameter of the
 * hit circle) — 52 on a finger is Apple's 44 pt minimum plus slack.
 */
export const handleSizing = (coarse = false) =>
  coarse ? { visualPx: 18, hitPx: 52 } : { visualPx: 14, hitPx: 18 };
